import { render, staticRenderFns } from "./TreeviewCatalogue.vue?vue&type=template&id=f379e764"
import script from "./TreeviewCatalogue.vue?vue&type=script&lang=js"
export * from "./TreeviewCatalogue.vue?vue&type=script&lang=js"
import style0 from "./TreeviewCatalogue.vue?vue&type=style&index=0&id=f379e764&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports